import { useState, useEffect } from 'react';

// Shared viewport hook — matches the 768px breakpoint used by the mobile sidebar drawer in App.css.
// Lets inline-styled pages swap layout (grids, tables, modals) by viewport without media queries.
export default function useIsMobile(query = '(max-width: 768px)') {
  const getMatch = () =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : false;
  const [isMobile, setIsMobile] = useState(getMatch);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // addEventListener('change') is modern; addListener is the Safari < 14 fallback
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);
  return isMobile;
}
